import { client } from '@/api/common';
import {
  API,
  BASE,
  URL_NOTIFICATIONS,
  URL_TENANTS,
  V1,
} from '@/lib/constants/urls';
import type { Notification } from '@repo/database/browser';
import type {
  FetchNotificationDto,
  ListResponse,
  NotificationCountResponseDto,
} from '@repo/api';

const getNotificationsUrl = (tenantId: string) =>
  `${BASE}${API}${V1}${URL_TENANTS}/${tenantId}${URL_NOTIFICATIONS}`;

export const fetchNotifications = async (
  tenantId: string,
  params?: FetchNotificationDto
): Promise<ListResponse<Notification>> => {
  const response = await client<ListResponse<Notification>>({
    url: getNotificationsUrl(tenantId),
    method: 'GET',
    params,
  });
  return response.data;
};

export const fetchUnreadCount = async (
  tenantId: string
): Promise<NotificationCountResponseDto> => {
  const response = await client<NotificationCountResponseDto>({
    url: `${getNotificationsUrl(tenantId)}/unread-count`,
    method: 'GET',
  });
  return response.data;
};

export const markNotificationAsRead = async (
  tenantId: string,
  notificationId: string
): Promise<Notification> => {
  const response = await client<Notification>({
    url: `${getNotificationsUrl(tenantId)}/${notificationId}/read`,
    method: 'PATCH',
  });
  return response.data;
};

export const markAllNotificationsAsRead = async (
  tenantId: string
): Promise<{ count: number }> => {
  const response = await client<{ count: number }>({
    url: `${getNotificationsUrl(tenantId)}/read-all`,
    method: 'PATCH',
  });
  return response.data;
};

export const deleteNotification = async (
  tenantId: string,
  notificationId: string
): Promise<Notification> => {
  const response = await client<Notification>({
    url: `${getNotificationsUrl(tenantId)}/${notificationId}`,
    method: 'DELETE',
  });
  return response.data;
};

export const deleteAllNotifications = async (
  tenantId: string
): Promise<{ count: number }> => {
  const response = await client<{ count: number }>({
    url: getNotificationsUrl(tenantId),
    method: 'DELETE',
  });
  return response.data;
};
